import { cn } from '@/lib/utils';

export interface SlotCostGridProps {
  costs: number[];
  /**
   * When set (e.g. deck builder), the first N slots are styled as filled and slot N as the next slot.
   */
  filledSlotCount?: number;
}

const tierStyles: Record<number, string> = {
  1: 'bg-muted text-muted-foreground',
  2: 'bg-amber-500/15 text-amber-700 dark:text-amber-400',
  3: 'bg-red-500/15 text-red-700 dark:text-red-400',
};

export function SlotCostGrid({ costs, filledSlotCount }: SlotCostGridProps) {
  if (costs.length === 0) return null;

  return (
    <div className="flex min-w-0 max-w-full flex-wrap gap-0.5">
      {costs.map((cost, i) => {
        const tierClass = tierStyles[cost] ?? tierStyles[3];
        const isUsed = filledSlotCount !== undefined && i < filledSlotCount;
        const isNext =
          filledSlotCount !== undefined && i === filledSlotCount && i < costs.length;

        return (
          <div
            key={i}
                       className={cn(
              'box-border flex size-5 shrink-0 items-center justify-center rounded text-[10px] font-semibold',
              tierClass,
              isUsed && 'ring-2 ring-inset ring-primary',
              isNext && 'ring-2 ring-inset ring-foreground'
            )}
          >
            {cost}
          </div>
        );
      })}
    </div>
  );
}
